'use strict';

angular.module('app')
  .service('checkoutService', function (Request, GTM, utils, $routeParams, $rootScope, $injector, Auth) {
    var checkout = {};

    checkout.getselectedProducts = function (data) {
      var list = _.filter(data, function (val) {
        return val.qty;
      });
      return list;
    };

    checkout.getDue = function (data) {
      return Request.post('checkout/due-now/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.checkout = function (data) {
      var checkoutData = _.clone(data);

      delete checkoutData.card;

      return Request.post('checkout/', checkoutData).then(function (res) {
        return res.data;
      });
    };

    checkout.getSeoInfo = function (slug) {
      return Request.get('shop/' + slug + '/seo/').then(function (res) {
        var data = res.data,
          seoInfo = {};

        data.businessType = utils.getType(data.businessType);


        _.each(data, function (val, key) {
          seoInfo[key.replace(/([A-Z])/g, '_$1').toLowerCase()] = val;
        });

        GTM.variables(seoInfo);

        return res.data;
      });
    };

    checkout.productKinds = function (sleepNumber, diving) {
      var list;

      if (sleepNumber && sleepNumber.length) {
        list = [{
          id: 1,
          title: 'Sleep & Dive package',
        }, {
          id: 2,
          title: 'Individual rooms',
        }, {
          id: 3,
          title: 'Only diving',
        }];
      } else {
        list = [{
          id: 2,
          title: 'Individual rooms',
        }, {
          id: 3,
          title: 'Only diving',
        }];
      }

      if (diving.length === 0) {
        list = _.reject(list, {
          id: 3,
        });
      }

      return list;
    };

    checkout.minus = function (val, field) {
      val[field] = utils.minus(val[field]);
    };

    checkout.plus = function (val, field) {
      val[field] = utils.plus(val[field]);
    };

    checkout.addProduct = function (variant, type, cabin, shop) {
      if (!cabin.selectedProductsCount) cabin.selectedProductsCount = 0;

      if (type) {
        if (type === 'plus') {
          variant.qty = variant.qty >= 99 ? 99 : variant.qty + 1;
          cabin.selectedProductsCount = variant.qty >= 99 ? 99 : cabin.selectedProductsCount + 1;

          GTM.products('checkout_la_cart_add_cabin', {
            currencyCode: 'USD',
            add: {
              products: [{
                title: shop.title,
                id: shop.id,
                price: $rootScope.setValue(+variant.priceNet, shop.currency, true, 'USD'),
                brand: shop.fleetTitle,
                category: 'Liveaboard',
                quantity: 1,
              }],
            },
          });
        } else {
          GTM.products('checkout_la_cart_remove_cabin', {
            currencyCode: 'USD',
            add: {
              products: [{
                title: shop.title,
                id: shop.id,
                price: $rootScope.setValue(+variant.priceNet, shop.currency, true, 'USD'),
                brand: shop.fleetTitle,
                category: 'Liveaboard',
                quantity: 1,
              }],
            },
          });
          if (variant.qty <= 0) {
            variant.qty = 0;
          } else {
            variant.qty -= 1;
            cabin.selectedProductsCount -= 1;
          }
        }
      }

      variant.itemAvailability = cabin.itemAvailability;
      variant.maxOccupancy = cabin.roomCategory.maxOccupancy;
      variant.roomId = cabin.roomCategory.id;

      if (!variant.qty) {
        variant.qty = 0;
      }
    };

    checkout.updateCard = function (data) {
      return Request.put('checkout/orders/' + data.uuid + '/card-update/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.setItinerary = function (scope, info, obj) {
      if (scope.operator.itineraryInfo && scope.operator.itineraryInfo.itinerary.slug && obj.itinerary.slug === scope.operator.itineraryInfo.slug) {
        return true;
      }

      scope.operator.itineraryInfo =  {
        id: obj.id,
        endDate: obj.endDate,
        startDate: obj.startDate,
        slug: obj.itinerary.slug,
        trip: obj,
        itinerary: {
          loading: true,
        },
      };

      return Request.get('shop/' + info.countrySlug + '/' + $routeParams.slug + '/itineraries/' + obj.itinerary.slug + '/').then(function (res) {
        scope.operator.itineraryInfo.itinerary = res.data;
        scope.operator.itineraryInfo.itinerary.loading = false;
        scope.operator.itineraryInfo.itinerary.days = utils.bindItinerary(scope.operator.itineraryInfo.itinerary.days);

        utils.bindLogistic(scope.operator.itineraryInfo.itinerary.descriptions);
      });
    };

    checkout.staffUpdate = function (data) {
      return Request.put('checkout/orders/' + data.uuid + '/staff/update/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.staffCheckout = function (data) {
      return Request.post('checkout/staff/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.blockSpot = function (data) {
      return Request.post('checkout/block/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.newOption = function (data) {
      return Request.post('checkout/staff/block/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.newOptionDR = function (data) {
      return Request.post('checkout/staff/dr/block/', data).then(function (res) {
        return res.data;
      });
    };

    checkout.getTripRequirements = function (id) {
      return Request.get('shop/itinerary/' + id  + '/requirements/').then(function (res) {
        return res.data;
      });
    };

    checkout.checkRequired = function (userAccount) {
      if (Auth.isStaff()) {
        if (userAccount && userAccount == $rootScope.user.id) {
          return true;
        }
        return false;
      } else if (Auth.isAffiliate()) {
        return false;
      }

      return true;
    };

    checkout.getInsurances = function () {
      return Request.get('booking/insurances/').then(function (res) {
        return res.data;
      });
    };

    checkout.getInclusions = function (data, filters) {
      return Request.get('booking/liveaboard/' + data.itinerary + '/inclusions/', filters).then(function (res) {
        var inclusions = _(res.data).filter(function (val) {
          if (val.isMandatory || val.isIncluded) {
            val.qty = checkout.setLimit(val, data, true);
          }

          return val.pricingId && ((val.isIncluded && !val.isMandatory) || (val.payedInAdvance && val.priceGross) || (val.payedInAdvance === false && (val.price || val.extraValue)));
        });
        return {
          groupedInclusions: inclusions.sortByAll(['isMandatory', 'isIncluded']).groupBy('belongsTo').value(),
          inclusions: inclusions.value(),
        };
      });
    };

    checkout.isDiverInclusionsLa = function (inclusion) {
      if ((utils.isBelongsTo(inclusion.belongsTo, 'LiveaboardCourses') && inclusion.isNondiverInclusion) || inclusion.isInsurance) {
        return true;
      }
      return utils.isBelongsTo(inclusion.belongsTo, 'Rental equipment') || utils.isBelongsTo(inclusion.belongsTo, 'DC Extras & Surcharge');
    };

    checkout.setLimit = function (course, data, isMandatory) {
      var limit = 1,
        duration = data.trip.duration,
        numberOfDives = data.trip.itinerary.totalNumberOfDives,
        numberOfDivers = data.diversNumber,
        numberOfGuests = data.diversNumber + data.nonDiversNumber,
        notDiverProducts = !utils.isBelongsTo(course.belongsTo, 'Rental equipment') && !utils.isBelongsTo(course.belongsTo, 'DC Extras & Surcharge');

      switch (+course.payedPer) {
      // Per Day
      case 0:
        limit = duration + 1;
        if (notDiverProducts) {
          limit *= numberOfGuests;
        }
        break;
        // Per Night
      case 10:
        limit = duration;

        if (notDiverProducts) {
          limit *= numberOfGuests;
        }
        break;
        // Per Dive
      case 20:
        limit = numberOfDives;

        if (notDiverProducts || isMandatory) {
          limit *= numberOfDivers;
        }
        break;
        // Per Trip
      case 30:
        limit = 1;

        if (notDiverProducts) {
          limit *= numberOfGuests;
        }

        break;
        // Per Diving day
      case 40:
        limit = duration - 1;

        if (notDiverProducts || isMandatory) {
          limit *= numberOfDivers;
        }

        break;
      // Transfers per persons
      case 42:
      case 46:
      case 49:
      case 50:
        limit = 1;
        if (notDiverProducts) {
          limit *= numberOfGuests;
        }
        break;
      // Transfers per vehicle
      case 44:
      case 48:
      case 55:
        limit = 1;
        break;
      case 60:
        limit = 1;
        if (notDiverProducts) {
          limit *= numberOfGuests;
        }
        break;
        // Per week
      case 70:
        limit = Math.ceil(duration / 7) * numberOfGuests;
        break;
      case 80:
        limit = 1;
        break;
      // Day/Cabin
      case 90:
        limit = (duration + 1) * data.cabinsNumber;
        break;
      // Night/Cabin
      case 100:
        limit = duration * data.cabinsNumber;
        break;
      default:
        break;
      }
      return limit;
    };

    checkout.validateVoucher = function (code) {
      return Request.post('coupons/validate/', {code: code}).then(function (res) {
        return res.data;
      });
    };

    return checkout;
  });
